export default "__VITE_ASSET__BeahK8rw__"